import type {
  CampaignDataSource,
  CampaignProductsParams,
} from '~/api/data-source/campaign';
import { campaignDataSource } from '~/api/data-source/campaign';
import type { MarketProductItem } from '~/api/model';
import { marketProductItemSchema, parseModelArray } from '~/api/model';

export interface CampaignRepository {
  getTodayCampaignProducts(
    params: CampaignProductsParams,
  ): Promise<MarketProductItem[]>;
}

export class CampaignRepositoryImpl implements CampaignRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: CampaignDataSource = campaignDataSource,
  ) {}

  async getTodayCampaignProducts(params: CampaignProductsParams) {
    const response = await this.dataSource.getTodayCampaignProducts(params);
    return parseModelArray(
      marketProductItemSchema,
      response,
      'MarketProductItem',
    );
  }
}

export const campaignRepository = new CampaignRepositoryImpl();
